
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-10 md:py-12 px-4 md:px-6" style={{ backgroundColor: '#C9F53B' }}>
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-5 md:gap-6">
          <div className="text-center md:text-left">
            <h3 className="text-xl md:text-2xl font-extrabold mb-1 md:mb-2 text-gray-900">EUH JUNG HEE</h3>
            <p className="mb-1 text-sm md:text-base font-semibold text-gray-700">어정희</p>
            <p className="text-xs md:text-sm text-gray-600">소속: 사람아이앤지</p>
          </div>

          <div className="flex gap-3 md:gap-4">
            <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full hover:scale-110 transition-all duration-300 cursor-pointer" style={{ backgroundColor: 'rgba(0,0,0,0.1)' }} aria-label="Instagram">
              <i className="ri-instagram-line text-lg md:text-xl text-gray-900"></i>
            </a>
            <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full hover:scale-110 transition-all duration-300 cursor-pointer" style={{ backgroundColor: 'rgba(0,0,0,0.1)' }} aria-label="YouTube">
              <i className="ri-youtube-line text-lg md:text-xl text-gray-900"></i>
            </a>
            <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full hover:scale-110 transition-all duration-300 cursor-pointer" style={{ backgroundColor: 'rgba(0,0,0,0.1)' }} aria-label="Blog">
              <i className="ri-article-line text-lg md:text-xl text-gray-900"></i>
            </a>
          </div>
        </div>

        <div className="mt-7 md:mt-8 pt-7 md:pt-8 text-center" style={{ borderTop: '1px solid rgba(0,0,0,0.15)' }}>
          <p className="text-xs md:text-sm text-gray-700">
            ⓒ {currentYear} EUH JUNG HEE. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
